import { StorageKeys } from '/src/lib/types';

/**
 * Wrapper for LocalStorage CRUD operations.
 */
export class Storage {
  public static get<T = unknown>(key: StorageKeys | string, defaultValue: T | string = ''): T | string | false {
    if (typeof window !== 'undefined') {
      const value = localStorage.getItem(key);
      if (value) return JSON.parse(value) as T;
      return defaultValue;
    }
    return false;
  }

  public static set(key: StorageKeys | string, value: unknown): void {
    if (typeof window !== 'undefined') {
      const valueToStr = JSON.stringify(value || '');
      localStorage.setItem(key, valueToStr);
    }
  }

  public static remove(key: StorageKeys | string): void {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(key);
    }
  }

  public static removeAll(): void {
    if (typeof window !== 'undefined') {
      localStorage.clear();
    }
  }
}
